import React, { useCallback, useMemo, useRef, useState } from 'react';
import { styled } from 'baseui';
import Colors, { type RGBColor } from './constants/colors';
import Hotkeys from './constants/hotkeys';
import IntentPanel from './intent-panel/intent-panel';
import TextPanel, { type TextIntentT } from './text-panel/text-panel';
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  width: '100%',
  height: '100%'
}));
const IntentContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  width: '320px',
  flexShrink: 0
}));
const TextContainer = styled('div', ({
  $theme
}) => ({
  flexGrow: 1,
  padding: '44px 20px',
  backgroundColor: $theme.colors.backgroundSecondary
}));
export type { TextIntentT };
type PropsT = {
  intents: string[];
  text: string;
  defaultIntents?: TextIntentT[];
  onUpdate: (intentArr: TextIntentT[]) => void;
  disablePartialLabelling?: boolean;
};
const TextLabelling = ({
  text,
  intents,
  onUpdate,
  defaultIntents,
  disablePartialLabelling
}: PropsT) => {
  const [intentList, setIntentList] = useState(() => {
    const customIntents = defaultIntents?.filter(textIntent => textIntent.intent.startsWith('Other:')).map(textIntent => textIntent.intent);
    return [...intents, ...(customIntents || [])];
  });
  const intentInfo = useRef({
    index: 0,
    intentMap: {}
  });
  const [currentIntent, setCurrentIntent] = useState(null);
  const getIntentInfo = (intentName: string): {
    color: RGBColor;
    hotkey: string | undefined | null;
  } => {
    let color = [0, 0, 0];
    let hotkey = null;
    const existingIntent = intentInfo.current.intentMap[intentName];
    if (existingIntent) return existingIntent;

    // No distinct colors left
    // @ts-expect-error todo(ts-migration) TS2322 Type 'number[] | undefined' is not assignable to type 'number[]'.
    color = intentInfo.current.index > 25 ? [0, 0, 0] : Colors[intentInfo.current.index];
    // @ts-expect-error missing null check
    hotkey = intentInfo.current.index > 36 ? null : Hotkeys[intentInfo.current.index];
    intentInfo.current.intentMap[intentName] = {
      color,
      hotkey
    };
    intentInfo.current.index++;
    // @ts-expect-error todo(ts-migration) TS2322 Type 'number[]' is not assignable to type 'RGBColor'.
    return {
      color,
      hotkey
    };
  };
  const intentArr = useMemo(() => {
    // eslint-disable-next-line react-hooks/refs
    return intentList.map(intent => {
      const {
        color,
        hotkey
      } = getIntentInfo(intent);
      return {
        value: intent,
        color,
        hotkey
      };
    });
  }, [intentList]);
  const onTextLabel = useCallback(intentArr => {
    setCurrentIntent(null);
    onUpdate(intentArr);
  }, [onUpdate]);
  const addNewIntent = (intent: string) => {
    setIntentList([...intentList, intent]);
  };
  return <Container>
      <TextContainer>
        <TextPanel text={text} defaultIntents={defaultIntents} onUpdate={onTextLabel} currentIntent={currentIntent} getIntentInfo={getIntentInfo} disablePartialLabelling={disablePartialLabelling} />
      </TextContainer>
      <IntentContainer>
        <IntentPanel intentArr={intentArr} currentIntent={currentIntent}
      // @ts-expect-error missing null check
      onIntentSelect={intent => setCurrentIntent(intent)} addNewIntent={addNewIntent} />
      </IntentContainer>
    </Container>;
};
export default TextLabelling;